module.exports = __webpack_public_path__ + "static/img/son5_active.b45f878d.jpg";